import { render, staticRenderFns } from "./AppraiserValuationsTable.vue?vue&type=template&id=2f66e16b&scoped=true&"
import script from "./AppraiserValuationsTable.vue?vue&type=script&lang=ts&"
export * from "./AppraiserValuationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66e16b",
  null
  
)

export default component.exports